import type { SVGAttributes } from "react";
import { siGithub } from "simple-icons";
import { cn } from "../helpers/class-names";

type GitHubIconProps = SVGAttributes<SVGSVGElement> & { title?: string };

export function GitHubIcon({ className, title, ...props }: GitHubIconProps) {
  return (
    <svg
      className={cn("ui-brand-icon", className)}
      viewBox="0 0 24 24"
      fill="currentColor"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      {...props}
    >
      {title && <title>{title}</title>}
      <path d={siGithub.path} />
    </svg>
  );
}
